import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const BridgeIconComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__bridgeIcon"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Bridge">
        <line
          id="Line 7"
          x1="0.75"
          y1="11.3105"
          x2="15.25"
          y2="11.3105"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="Group 2">
          <path
            id="Line 8"
            d="M4 2.06055C4 2.06055 4 6.06055 8 6.06055C12 6.06055 12 2.06055 12 2.06055"
            stroke={colorVar}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Line 10"
            d="M1 5.75285C4 4.72111 4 2.06055 4 2.06055L4 14.0605"
            stroke={colorVar}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Line 11"
            d="M15 5.75285C12 4.72111 12 2.06055 12 2.06055L12 14.0605"
            stroke={colorVar}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export const BridgeIcon = withIcon(BridgeIconComponent);
